import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterParams, StarbaseDataService, SubscriptionCadence } from 'starbase-launcher';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';
import { UserGroupModel_ext } from '../models/lu_usergroup';
import { map, retry } from 'rxjs/operators';
import { LU_SubscriptionPriceModel_ext } from '../models/lu_subscriptionprice';

@Injectable({
  providedIn: 'root'
})
export class LuSubscriptionPriceService extends StarbaseDataService<LU_SubscriptionPriceModel_ext> {

  protected _staleDataTimeout = 2000;
  protected _getOneUri = '/api/SubscriptionPrice/';
  protected _getAllUri = '/api/SubscriptionPrice';
  protected _postUri = '/api/SubscriptionPrice';
  protected _putUri = '/api/SubscriptionPrice/';
  protected _deleteUri = '/api/SubscriptionPrice/';
  protected _broadSearchUri: string;
  private _groupsUri = '/api/LU_UserGroupModel';
  private _getActiveSubscriptionsUri = '/api/SubscriptionPrice/GetActiveSubscriptionPrices';

  constructor(private _http: HttpClient, private _webApi: WebApiService) {
    super(_http, _webApi);
  }

  public get getActiveSubscriptionsUri() {
    return this._getActiveSubscriptionsUri;
  }

  getUserGroups(): Observable<UserGroupModel_ext[]> {
    return this._http.get<UserGroupModel_ext[]>(
      this.server + this._groupsUri,
      { headers: this._webApi.getApiHeaders('get') }
    );
  }

  public getAllData(url: string, retryCount?: number): Observable<LU_SubscriptionPriceModel_ext[]> {
    return super.getAllData(url, retryCount).pipe(
      map((x: LU_SubscriptionPriceModel_ext[]) => x.map(
        (y: LU_SubscriptionPriceModel_ext) => {
          // y.userGroup = y.subscriptionUserGroup;
          // y.subscriptionUserGroup = null;
          if (y.subscriptionUserGroup) {
            y.subscriptionUserGroup.selected = true;
          }
          y.cadenceDisp = {
            selected: true,
            key: SubscriptionCadence[y.cadence],
            value: y.cadence
          };

          return y;
        })
      )
    );
  }

  // public postData(url: string, postObject: LU_SubscriptionPriceModel_ext): Observable<LU_SubscriptionPriceModel_ext> {
  //   // postObject.userGroup = null;
  //   return super.postData(url, postObject);
  // }

  // public putData(url: string, id: string, changedObject: LU_SubscriptionPriceModel_ext): Observable<LU_SubscriptionPriceModel_ext> {
  //   // changedObject.userGroup = null;
  //   return super.putData(url, id, changedObject);
  // }

}
